export default __webpack_public_path__ + "static/media/europe_exam.34742e5c.png";